import mickeyMouse from "/api/mickey-mouse";
import me from "/api/me";
import books from "/api/books";
import promotions from "/api/promotions";
import settings from "/api/settings";
import plans from "/api/plans";
import creditBundles from "/api/credit-bundles";

export default {
  mickeyMouse,
  me,
  books,
  promotions,
  settings,
  plans,
  creditBundles
};
